import React from "react";
import { Skeleton } from "@heroui/skeleton";

const CompanyOverviewSkeleton = () => {
  return (
    <section id="overview" className="p-5 bg-white shadow-md rounded-lg border">
      {/* Mimic the title and basic info style */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Skeleton className="h-10 mb-10 " />

          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className="mb-2">
              <Skeleton className="h-4 w-3/4" />
            </div>
          ))}
        </div>

        {/* Mimic the snowflake chart and button */}
        <div className="flex flex-col items-center justify-center">
          <Skeleton className="h-72 w-64 mb-4" />{" "}
          {/* Placeholder for the chart */}
          <Skeleton className="h-10 w-48 rounded-lg" />{" "}
          {/* Placeholder for the button */}
        </div>
      </div>
    </section>
  );
};

export default CompanyOverviewSkeleton;
